/**
 * TanStack Query キー定義
 *
 * @graph-stack ux-mirror
 * @graph-domain UX
 * @graph-business TanStack Queryキーファクトリ。overview/screens/funnels/serviceHealth/users/styling/errorsのキャッシュキーを一元管理
 * @graph-connects none
 */

export const queryKeys = {
  auth: {
    me: ['auth', 'me'] as const,
  },
  overview: {
    kpi: (date?: string) => ['overview', 'kpi', date] as const,
    trends: (startDate: string, endDate: string, metrics: string[]) =>
      ['overview', 'trends', startDate, endDate, metrics] as const,
    topScreens: (startDate: string, endDate: string) =>
      ['overview', 'top-screens', startDate, endDate] as const,
  },
  screens: {
    list: (startDate: string, endDate: string, service?: string) =>
      ['screens', 'list', startDate, endDate, service] as const,
    metrics: (name: string, startDate: string, endDate: string) =>
      ['screens', name, 'metrics', startDate, endDate] as const,
    events: (name: string, startDate: string, endDate: string) =>
      ['screens', name, 'events', startDate, endDate] as const,
    availableDimensions: (name: string, startDate: string, endDate: string) =>
      ['screens', name, 'available-dimensions', startDate, endDate] as const,
    dimensions: (name: string, startDate: string, endDate: string, dim: string) =>
      ['screens', name, 'dimensions', startDate, endDate, dim] as const,
  },
  funnels: {
    list: () => ['funnels', 'list'] as const,
    detail: (id: string, startDate: string, endDate: string) =>
      ['funnels', id, startDate, endDate] as const,
    dimensions: (id: string, startDate: string, endDate: string, dim: string) =>
      ['funnels', id, 'dimensions', startDate, endDate, dim] as const,
    details: (id: string, startDate: string, endDate: string, analysisType: string) =>
      ['funnels', id, 'details', startDate, endDate, analysisType] as const,
  },
  serviceHealth: {
    availability: (startDate: string, endDate: string) =>
      ['service-health', 'availability', startDate, endDate] as const,
  },
  users: {
    timeline: (userId: string, startDate: string, endDate: string) =>
      ['users', 'timeline', userId, startDate, endDate] as const,
  },
  styling: {
    kpi: (date?: string) => ['styling', 'kpi', date] as const,
    trends: (startDate: string, endDate: string) =>
      ['styling', 'trends', startDate, endDate] as const,
    eventBreakdown: (startDate: string, endDate: string) =>
      ['styling', 'event-breakdown', startDate, endDate] as const,
    errors: (startDate: string, endDate: string) =>
      ['styling', 'errors', startDate, endDate] as const,
    sessionTiming: (startDate: string, endDate: string) =>
      ['styling', 'session-timing', startDate, endDate] as const,
    skuAnalysis: (startDate: string, endDate: string) =>
      ['styling', 'sku-analysis', startDate, endDate] as const,
    positionAnalysis: (startDate: string, endDate: string) =>
      ['styling', 'position-analysis', startDate, endDate] as const,
    underexposedSkus: (startDate: string, endDate: string) =>
      ['styling', 'underexposed-skus', startDate, endDate] as const,
    filterPatterns: (startDate: string, endDate: string) =>
      ['styling', 'filter-patterns', startDate, endDate] as const,
    filterDimensionUsage: (startDate: string, endDate: string) =>
      ['styling', 'filter-dimension-usage', startDate, endDate] as const,
    stylistTimeline: (accountId: string, startDate: string, endDate: string) =>
      ['styling', 'stylist-timeline', accountId, startDate, endDate] as const,
  },
  errors: {
    dailyRates: (startDate: string, endDate: string) =>
      ['errors', 'daily-rates', startDate, endDate] as const,
    breakdown: (startDate: string, endDate: string) =>
      ['errors', 'breakdown', startDate, endDate] as const,
    messages: (startDate: string, endDate: string) =>
      ['errors', 'messages', startDate, endDate] as const,
  },
};
